// extracted by mini-css-extract-plugin
var _1 = "SettingsFormSectionButtons-moduleSettingsFormSectionButtons__zciEZ SettingSectionButtons-moduleSettingSectionButtons__Mambo";
export { _1 as "SettingsFormSectionButtons" }
